import { userPrivileges } from 'api/User/selectors'
import { fetchCountries } from 'home/actions'
import { countries } from 'home/selectors'
import { connect } from 'react-redux'

import * as actions from './actions'
import RankingsBoxFilters from './RankingsBoxFilters'
import * as selectors from './selectors'

const mapStateToProps = state => ({
  areFiltersExpanded: selectors.areFiltersExpanded(state),
  countries: countries(state),
  indicator: selectors.indicator(state),
  isModalOpen: selectors.isFilterCountryModalOpen(state),
  ranking: selectors.ranking(state),
  rankingsCountries: selectors.rankingsCountries(state),
  selectedCountries: selectors.selectedCountries(state),
  selectedCountriesCount: selectors.selectedCountriesCount(state),
  userPrivileges: userPrivileges(state),
})

const mapDispatchToProps = {
  fetchCountries,
  hideFilterCountryModal: actions.hideFilterCountryModal,
  openFilterCountryModal: actions.openFilterCountryModal,
  setIndicator: actions.setIndicator,
  setRanking: actions.setRanking,
  toggleAreFiltersExpanded: actions.toggleAreFiltersExpanded,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingsBoxFilters)
